import { gql } from "lib/apolloClient";

export const plannerElementNodeFragment = {
  plannerElementNode: gql`
    fragment plannerElementNodeItem on PlannerElementNode {
      id
      label
      subText
      type
      depth
      parent
      children
    }
  `,
  plannerElementNodeWithAssocParents: gql`
    fragment plannerElementNodeWithAssocParentsItem on PlannerElementNode {
      id
      label
      subText
      code
      type
      depth
      parent
      children
      associatedParents {
        id
        ... on Grade {
          id
          name
        }
        ... on Subject {
          id
          name
        }
        ... on SubjectGroup {
          id
          name
        }
        ... on Course {
          id
          title
        }
        ... on PlannerElementNode {
          id
          label
        }
      }
    }
  `,
};
